import type { Locale } from "vue-i18n";
import type { Booth, FavoriteBooth, FavoriteCircle, ICircleJyunbikaiWithHallNumber, MapArea, PrintParam } from "~/types/entity/cWebCatalog";

type Space = {
  x1: number
  y1: number
  x2: number
  y2: number
}

export type FavoriteCirclePosition = {
  favorite: FavoriteCircle
  color: string | undefined
  detail: ICircleJyunbikaiWithHallNumber | undefined
  writer: string | undefined
  spaces: Space[]
}

// Src/ComiketWebCatalog/Catalog.ReportViewer.Console/Infrastructure/IndexViewModel.cs
export const 印刷表示形式 = {
  UNKNOWN: 0,
  会場マップお気に入りサークルカットリスト: 1,
  サークルカットリスト: 2,
  会場マップお気に入り: 3,
  会場マップ白地図: 4,
  マッピングカットリスト: 5,
  サークルリスト: 6,
  マッピングリスト: 7,
  会場マップお気に入りサークルリスト: 8,
  マッピングカットリストA3: 9,
  マッピングリストA3: 10
} as const;

export type PrintType = typeof 印刷表示形式[keyof typeof 印刷表示形式];

// 未定義・範囲外は UNKNOWN にフォールバック
export const toPrintType = (value: number | undefined | null): PrintType =>
  (Object.values(印刷表示形式) as number[]).includes(value as number)
    ? value as PrintType // TODO(as-cast): 強制型キャスト。安全な型付けへ置換を検討
    : 印刷表示形式.UNKNOWN;

type PrintRequestModel = {
  key: string
  printParam: PrintParam
  /**
   * このモデルの時点では day, area は1つ
   */
  day: number
  area: MapArea
  /**
   * ホール絞り込み時のホール番号 (例 "1")。halls クエリ未指定時は undefined。
   * 設定時は 1 ページ 1 ホールで bounding rect に基づいたズーム印刷を行う。
   */
  hallNumber?: string
  /**
   * お気に入り地図描画用のデータ
   *
   * 印刷用ページはUIがないため
   * page レベルで構築して下に渡している
   *
   * UI のあるページでお気に入りの動的な挙動がある場合は
   * 更新粒度を別途考慮した方がよい (理想的には見える範囲にあるもののみ取得するべき)
   */
  favoriteCircles: FavoriteCirclePosition[]
  locale: Locale
}

type FavoriteBoothPosition = {
  favorite: FavoriteBooth
  color: string | undefined
  detail: Booth | undefined
  spaces: Space[]
}

type PrintRequestBoothModel = {
  key: string
  printParam: PrintParam
  /**
   * このモデルの時点では area は1つ
   */
  area: MapArea
  /**
   * お気に入り地図描画用のデータ
   *
   * 印刷用ページはUIがないため
   * page レベルで構築して下に渡している
   *
   * UI のあるページでお気に入りの動的な挙動がある場合は
   * 更新粒度を別途考慮した方がよい (理想的には見える範囲にあるもののみ取得するべき)
   */
  favoriteBooths: FavoriteBoothPosition[]
  locale: Locale
}

export type { PrintRequestModel, PrintRequestBoothModel };
